var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.params.data.carrier.name)+" ")]),(_vm.params.data.carrier.name !== 'CORREIOS')?_c('feather-icon',{attrs:{"icon":"TruckIcon","svgClasses":"h-5 w-5 hover:text-primary cursor-pointer","title":"Trocar para Correios"},on:{"click":_vm.save_changes}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }